import './ccf-sentiment-icon.module.scss';

import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfSentimentIconProps extends SvgIconProps {
  strokeColor?: string;
}

/**
 * CcfSentimentIcon used to disply sentiment icon in the App space
 * @param props - CcfSentimentIconProps
 * @example -- <CcfSentimentIcon />
 */
export function CcfSentimentIcon(props: CcfSentimentIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 26 26">
      <g id="ic_sentiment" clipPath="url(#clip-ic_sentiment)">
        <g id="ic_app_sentiment" transform="translate(1 1)">
          <g id="Group_120266" data-name="Group 120266" transform="translate(0)">
            <g id="Group_120249" data-name="Group 120249" transform="translate(0)">
              <g id="Group_120274" data-name="Group 120274">
                <path id="frown" d="M10.4,12.8a1.2,1.2,0,1,0-1.2-1.2A1.2,1.2,0,0,0,10.4,12.8ZM14,2A12,12,0,1,0,26,14,12,12,0,0,0,14,2Zm0,21.6A9.6,9.6,0,1,1,23.6,14,9.6,9.6,0,0,1,14,23.6Zm3.6-13.2a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,17.6,10.4Z" transform="translate(-2 -2)"/>
                <line id="Line_190" data-name="Line 190" x1="9.101" transform="translate(7.447 16.441)" fill="none" stroke={props.strokeColor ? props.strokeColor : "#526b7a"} strokeLinecap="round" strokeWidth="2"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfSentimentIcon;
